import dayjs from 'dayjs';
import calender from 'dayjs/plugin/calendar';
import { CalendarOptions } from './interface';
import { timezoneAbbr } from '../../utils/tz-abbr';
import { DEFAULT_CALENDAR_FORMATS } from './constants';

dayjs.extend(calender);

export const getCalenderTime = (value: number | Date | dayjs.Dayjs, options: CalendarOptions) => {
  if (!value && options.hideZeroTimestamp) {
    return '-';
  }

  const formats = options.formats || DEFAULT_CALENDAR_FORMATS;
  const { showTimezone } = options;
  const { referenceTime } = options;

  let op = dayjs(value).calendar(referenceTime, formats);

  if (showTimezone) {
    let date;

    if (value instanceof Date) {
      date = value;
    } else if (dayjs.isDayjs(value)) {
      date = value.toDate();
    } else if (typeof value === 'string' || typeof value === 'number') {
      date = new Date(value);
    } else {
      return op;
    }

    op += ` (${timezoneAbbr(date)})`;
  }

  return op;
};

export const removeObjectEntriesWithNull = (obj: { [key: string]: unknown }) => {
  return Object.entries(obj).reduce((acc: { [key: string]: unknown }, [key, value]) => {
    if (value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {});
};
